module.exports = __webpack_public_path__ + "img/socialStatuses.617cf336.svg";